import ReportsAdapter from './base';

export default class RubricState extends ReportsAdapter {
  modelNamePlural = 'rubric-states';
}
